import { render, staticRenderFns } from "./category-bisac.vue?vue&type=template&id=9c1080e4&scoped=true&"
import script from "./category-bisac.vue?vue&type=script&lang=js&"
export * from "./category-bisac.vue?vue&type=script&lang=js&"
import style0 from "./category-bisac.vue?vue&type=style&index=0&id=9c1080e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1080e4",
  null
  
)

export default component.exports